import PersonIcon from "@mui/icons-material/Person";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const mainField = "id";

const dataFieldConfig = [
  {
    id: "display_name",
    field: "display_name",
    align: "center",
    disablePadding: false,
    label: "名稱",
  },

  {
    id: "email",
    field: "email",
    align: "center",
    disablePadding: false,
    label: "電郵",
  },

  // {
  //   id: "face_id",
  //   field: "face_id",
  //   align: "center",
  //   disablePadding: false,
  //   label: "FaceID",
  // },
  // {
  //   id: "group",
  //   field: "group",
  //   align: "center",
  //   disablePadding: false,
  //   label: "組別",
  // },
  // {
  //   id: "group_num",
  //   field: "group_num",
  //   align: "center",
  //   disablePadding: false,
  //   label: "組別編號",
  // },
  // new_field
  {
    id: "filename",
    field: "filename",
    align: "center",
    disablePadding: false,
    label: "圖片檔名字",
  },
];

const fetchDataConfig = {
  url: "/adminMember/queryWithOrg",
  extraQuery: [{ key: "org", field: "orgId" }],
  // fixedFilter: [],
};

const tableActionConfig = [

];

const filterConfig = [
  {
    type: "text",
    label: "按 名稱、電郵 搜索",
    field: "display_name,email",
  },
];

const fetchResultModifier = (data) => {
  data.forEach((item) => {
    console.debug("fetchResultModifier: item", item);
    item.filename = `face_${item.id}.jpg`;
  });
}

const TableConfig = {
  mainField,
  dataFieldConfig,
  fetchDataConfig,
  tableActionConfig,
  filterConfig,
  fetchResultModifier,
};

export default TableConfig;
